<div class="floatinghead floatinghead-xs clearfix margin-top-20" *ngIf="!showNodata">
  <div class="clearfix p-1">
    <div class="d-flex align-item-center data-filter-header flex-tab-row">
      <div class="mr-auto">
        <h2 class="mainhead"><span class="text">Prospect</span></h2>
      </div>
      <div class="d-flex filter-header-rt" style="align-items:normal;">
        <label *ngIf="!isFromDashboard && AddEditPermission" class="custom-checkbox margin-right-15 margin-top-10 margin-bottom-0" for="checkboxprivilageForSeller">
          <input type="checkbox" #chkprivilageForSeller [disabled]="property.IsDeleted" [(ngModel)]="property.ShowProspectToSeller" id="checkboxprivilageForSeller" (ngModelChange)="setSellerPrivilage(chkprivilageForSeller.checked)">Share Prospects with Seller
          <i></i>
        </label>
        <div class="select-dropdown multiselectdesign margin-right-15  multi-check-dropdown ">
          <!--<angular2-multiselect [data]="statusList" [(ngModel)]="statusIDs" [settings]="defaultTypeSettings" (ngModelChange)="redrawTable()"></angular2-multiselect>-->
          <mat-form-field>
            <mat-select placeholder="Filter By Status" [(ngModel)]="statusIDs" (ngModelChange)="redrawTable()" multiple>
              @if(statusIDs?.length > 1) {
              <mat-select-trigger>
                <span>{{ statusIDs.length }} items selected</span>
              </mat-select-trigger>
              }
              @for (status of statusList; track status) {
              <mat-option [value]="status.id" class="multi-dropdown-item">{{status.itemName}}</mat-option>
              }
              <mat-option class="matoptionnodata" *ngIf="statusList.length === 0" disabled>
                Nothing found...
              </mat-option>
            </mat-select>
          </mat-form-field>

        </div>
        <div class="select-dropdown multiselectdesign margin-right-15 multi-check-dropdown ">
          <!--<angular2-multiselect [data]="feedbackList" [(ngModel)]="feedbackIds" [settings]="defaultFeedbackSettings" (ngModelChange)="redrawTable()"></angular2-multiselect>-->
          <mat-form-field>
            <mat-select placeholder="Filter By Feedback" [(ngModel)]="feedbackIds" (ngModelChange)="redrawTable()" multiple>
              @if(feedbackIds?.length > 1) {
              <mat-select-trigger>
                <span>{{ feedbackIds.length }} items selected</span>
              </mat-select-trigger>
              }
              @for (feedback of feedbackList; track feedback) {
              <mat-option [value]="feedback.id" class="multi-dropdown-item">{{feedback.itemName}}</mat-option>
              }
              <mat-option class="matoptionnodata" *ngIf="feedbackList.length === 0" disabled>
                Nothing found...
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div *ngIf="AddEditPermission && !isFromDashboard" class="btn-group right-btn rightdropdown" dropdown>
          <button id="button-basic" dropdownToggle type="button" class="btn  btn-circle btn-green margin-bottom dropdown-toggle"
                  aria-controls="dropdown-basic">
            <i aria-hidden="true" class="fa fa-plus icon"></i>
          </button>
          <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right"
              role="menu" aria-labelledby="button-basic">
            <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="onAddOrEdit(Prospects,'portfolio-bov-modal edit-prospect-modal')">Add Prospects</a></li>
            <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="onImportProspects(ImportProspects,'portfolio-bov-modal')">Import Prospects</a></li>
          </ul>
        </div>
        <!--<a *ngIf="AddEditPermission && !isFromDashboard" [ngClass]="{'disable-link':property.IsDeleted}" class="filter btn  btn-circle btn-green adduserbtn" href="javascript:void(0);" (click)="onAddOrEdit(Prospects,'panlestyle')" tooltip='Add Prospects'><i class="fa fa-plus icon" aria-hidden="true"></i></a>-->
      </div>
    </div>
  </div>
</div>
<div class="table-responsive" *ngIf="!showNodata">
  <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
    <thead>
      <tr>
        <th [hidden]="!(AddEditPermission && !isFromDashboard)" style="width:100px" data-orderable="false">Action</th>
        <th [hidden]="isSeller" class="whitespacenowrap">Date</th>
        <th class="min-width-td sticky-left z-100">Prospect</th>
        <th>Company</th>
        <th>OM Downloaded</th>
        <th>NDA Executed</th>
        <th>Property / Portfolio</th>
        <th>Status</th>
        <th>Feedback</th>
        <th style="width: 130px !important" data-orderable="false">
          Notes
          <span class="textlink pull-right" *ngIf="this.showNotes==false" style="font-size: 11px;padding-left:0px !important;" (click)="ExpandNotes()">Expand Notes</span>
          <span class="textlink pull-right" *ngIf="this.showNotes==true" style="font-size: 11px;padding-left:0px !important;" (click)="ExpandNotes()">Collapse Notes</span>
        </th>

      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let prospects of lstProspects;let i = index;">
        <tr>
          <td [hidden]="!(AddEditPermission && !isFromDashboard)" style="width:100px" [ngClass]="prospects.IsHighPriority === 1 ? 'prospects-highpriority' : ''">
            <div class="d-flex align-item-center">
              <a href="javascript:void(0);" [ngClass]="{'favClicked':(prospects.IsHighPriority === 1)}" [tooltip]="prospects.IsHighPriority === 1 ? 'Remove Priority' : 'Add Priority'"  (click)="changeHighPriority(prospects);" class="margin-right-10"><i class="fa fa-heart" aria-hidden="true" style="font-size:17px;"></i></a>
              <a [ngClass]="{'disable-link':property.IsDeleted}" class="blueone quick-edit" tooltip="Edit" href="javascript:void(0);" (click)="onAddOrEdit(Prospects,'portfolio-bov-modal edit-prospect-modal',prospects)"><i class="icofont icofont-ui-edit" aria-hidden="true"></i></a>
              <a [ngClass]="{'disable-link':property.IsDeleted}" class="remove" tooltip="Remove" href="javascript:void(0);" (click)="removeModel(template,'deletemodal',prospects)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
              <a [ngClass]="{'disable-link':property.IsDeleted}" *ngIf="prospects.NDAExecuted && prospects.LstDocuments != null && prospects.LstDocuments.length > 0 && prospects.LstDocuments[0].Id > 0" (click)="docList(Documents,'panlestyle',prospects)" class="view" href="javascript:void(0);" tooltip="Attachments" ng-reflect-tooltip="Attachments">
                <i style="font-size:14px;" class="fa fa-paperclip" aria-hidden="true"></i>
              </a>
           </div>
          </td>

          <td [hidden]="isSeller" class="whitespacenowrap" [ngClass]="prospects.IsHighPriority === 1 ? 'prospects-highpriority' : ''">
            <p class="d-flex">
              <span *ngIf="prospects.PCount > 1" (click)="showPreviousEntries(prospects.Id,i)" class="btn-collapse" [class.span-open]="lstProspects[i].showPrevEntries">
                <i class="fa fa-angle-right" aria-hidden="true"></i>
              </span>
              {{prospects.ModifiedDate ? ( prospects.ModifiedDate | date:'MM/dd/yyyy') : '-'}}
            </p>
          </td>
          <td [hidden]="!AddEditPermission" class="invited-user " [ngClass]="prospects.IsHighPriority === 1 ? 'prospects-highpriority' : ''">
            <div style="display:table">
              <p>
                <a href="javascript:void(0);" routerLink="/prospect-detail/" [queryParams]="{prospectId:prospects.ProspectMasterId,prevroute:'Property Details',link:router.url}">
                  {{ prospects.ProspectName }}
                </a>
              </p>
              <p *ngIf="prospects.Phone">{{ (prospects.Phone!=null&&prospects.Phone!='') ? FormatPhone(prospects.Phone):'' }}</p>
              <p *ngIf="prospects.Email">{{prospects.Email}}</p>
            </div>
          </td>
          <td [ngClass]="prospects.IsHighPriority === 1 ? 'prospects-highpriority' : ''">{{prospects.CompanyName != null && prospects.CompanyName.length > 0 ?prospects.CompanyName : "Private" }}</td>
          <td style="padding-bottom:34px" [ngClass]="prospects.IsHighPriority === 1 ? 'prospects-highpriority' : ''">
            <label class="custom-checkbox margin-right-20 margin-bottom-0" for="checkboxOMDownloads_{{i+1}}">
              <input [disabled]="property.IsDeleted || isFromDashboard || !AddEditPermission" type="checkbox" [(ngModel)]="prospects.OMDownloads" id="checkboxOMDownloads_{{i+1}}" (ngModelChange)="updateCheckBox(prospects)">
              <i></i>
            </label>
          </td>
          <td style="padding-bottom:34px" [ngClass]="prospects.IsHighPriority === 1 ? 'prospects-highpriority' : ''">
            <label class="custom-checkbox margin-bottom-0 margin-right-20" for="checkboxNDAExecuted_{{i+1}}">
              <input [disabled]="property.IsDeleted || isFromDashboard || !AddEditPermission" type="checkbox" [(ngModel)]="prospects.NDAExecuted" id="checkboxNDAExecuted_{{i+1}}" (ngModelChange)="updateCheckBox(prospects)">
              <i></i>
            </label>
          </td>
          <td [ngClass]="prospects.IsHighPriority === 1 ? 'prospects-highpriority' : ''">
            {{prospects.OfferOn}}
          </td>
          <td [ngClass]="prospects.IsHighPriority === 1 ? 'prospects-highpriority' : ''">
            {{prospects.StatusName != null && prospects.StatusName.length > 0 ? prospects.StatusName : "-"}}
          </td>
          <td [ngClass]="prospects.IsHighPriority === 1 ? 'prospects-highpriority' : ''">
            {{prospects.FeedbackName != null && prospects.FeedbackName.length > 0 ? prospects.FeedbackName : "-"}}
          </td>
          <td [ngClass]="prospects.IsHighPriority === 1 ? 'prospects-highpriority' : ''">
            <p class="td-note" *ngIf="!showNotes" style="max-width:120px;min-width:120px;">
              {{prospects.ShortDescription ? prospects.ShortDescription : prospects.Notes ? prospects.Notes : '-'}}
              <a *ngIf="prospects.Notes?.length > 25 " style="cursor:pointer" href="javascript:void(0);" popover="{{prospects.Notes}}" placement="bottom" triggers="focus"><span class="a-link whitespacenowrap" style="font-size:10px">View More</span></a>
            </p>
            <p class="td-note" *ngIf="showNotes" style="max-width:120px;min-width:120px;">
              {{prospects.Notes ? prospects.Notes : '-'}}

            </p>
          </td>

        </tr>

        <ng-container *ngIf="this.lstProspects[i].showPrevEntries">
          <tr *ngFor="let prospectChild of prospects.PrevEntry; let k=index" [class.tr-collapse]="this.lstProspects[i].showPrevEntries">
            <td [hidden]="!(AddEditPermission && !isFromDashboard)" style="width:100px">
              <a [ngClass]="{'disable-link':property.IsDeleted}" class="blueone quick-edit" tooltip="Edit" href="javascript:void(0);" (click)="onAddOrEdit(Prospects,'portfolio-bov-modal edit-prospect-modal',prospectChild)"><i class="icofont icofont-ui-edit" aria-hidden="true"></i></a>
              <a [ngClass]="{'disable-link':property.IsDeleted}" class="remove" tooltip="Remove" href="javascript:void(0);" (click)="removeModel(template,'deletemodal',prospectChild)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
              <a [ngClass]="{'disable-link':property.IsDeleted}" *ngIf="prospectChild.NDAExecuted && prospectChild.LstDocuments != null && prospectChild.LstDocuments.length > 0 && prospectChild.LstDocuments[0].Id > 0" (click)="docList(Documents,'panlestyle',prospectChild)" class="view" href="javascript:void(0);" tooltip="Attachments" ng-reflect-tooltip="Attachments">
                <i style="font-size:14px;" class="fa fa-paperclip" aria-hidden="true"></i>
              </a>
            </td>
            <td [hidden]="isSeller" class="whitespacenowrap">{{prospectChild.ModifiedDate ? ( prospectChild.ModifiedDate | date:'MM/dd/yyyy') : '-'}}</td>
            <td [hidden]="!AddEditPermission" class="invited-user ">
              <div style="display:table">
                <p>
                  <a href="javascript:void(0);" routerLink="/prospect-detail/" [queryParams]="{prospectId:prospectChild.ProspectMasterId}">
                    {{ prospectChild.ProspectName }}
                  </a>
                </p>
                <p *ngIf="prospectChild.Phone">{{ prospectChild.Phone!=null&&prospectChild.Phone!='' ? (prospectChild.Phone | phone):'' }}</p>
                <p *ngIf="prospectChild.Email">{{prospectChild.Email}}</p>
              </div>
            </td>
            <td>{{prospectChild.CompanyName != null && prospectChild.CompanyName.length > 0 ?prospectChild.CompanyName : "Private" }}</td>
            <td style="padding-bottom:34px">
              <label class="custom-checkbox margin-right-20 margin-bottom-0" for="checkboxOMDownloads_{{i}}">
                <input [disabled]="property.IsDeleted || isFromDashboard || !AddEditPermission || (prospectChild.IsOmOrNda == true) ? true: null" type="checkbox" [(ngModel)]="prospectChild.OMDownloads" id="checkboxOMDownloads_{{i}}" (ngModelChange)="updateCheckBox(prospectChild)">
                <i></i>
              </label>
            </td>
            <td style="padding-bottom:34px">
              <label class="custom-checkbox margin-bottom-0 margin-right-20" for="checkboxNDAExecuted_{{i}}">
                <input [disabled]="property.IsDeleted || isFromDashboard || !AddEditPermission || (prospectChild.IsOmOrNda == true) ? true: null" type="checkbox" [(ngModel)]="prospectChild.NDAExecuted" id="checkboxNDAExecuted_{{i}}" (ngModelChange)="updateCheckBox(prospectChild)">
                <i></i>
              </label>
            </td>
            <td>
              {{prospectChild.OfferOn}}
            </td>
            <td>
              {{prospectChild.StatusName != null && prospectChild.StatusName.length > 0 ? prospectChild.StatusName : "-"}}
            </td>
            <td>
              {{prospectChild.FeedbackName != null && prospectChild.FeedbackName.length > 0 ? prospectChild.FeedbackName : "-"}}
            </td>
            <td>
              {{prospectChild.Notes != null && prospectChild.Notes.length > 0 ? prospectChild.Notes : "-"}}
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </tbody>
    <tfoot>
      <tr *ngIf="lstProspects?.length == 0 &&!IsLoading">
        <td colspan="9" class="odd no-data-available">
          <div class="nodata">
            <i class="fa fa-exclamation-triangle icon"></i>
            <p>No Data Available</p>
          </div>
        </td>
      </tr>
    </tfoot>
  </table>
</div>

<div class="col-md-12" *ngIf="showNodata">
  <div class="border-div">
    <div class="nodata">
      <p>Data will start populating once property reaches the marketing phase.</p>
    </div>
  </div>
</div>


<ng-template #Prospects>
  <app-prospects-add [propertyId]="propertyId" [prospectId]="prospects?.Id" [prospect]="prospects" [IsPortfolio]="IsPortfolio" (close)="onClose()" (save)="onSave($event)"></app-prospects-add>
</ng-template>
<ng-template #ImportProspects>
  <app-import-prospects-add [propertyId]="propertyId" [propertyType]="propertyTypeIds" [category]="propertysubcategories" [IsPortfolio]="IsPortfolio" (close)="onClose()" (save)="onSave($event)"></app-import-prospects-add>
</ng-template>

<ng-template #template>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Prospect ?</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure to delete ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="removeModalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="updateProspect();removeModalRef.hide();">Delete</button>
    </div>
  </div>
</ng-template>
<ng-template #Documents>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Attachments</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="docClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <ng-container *ngFor="let doc of documentsList; let i= index">
        <p class="file-view-list">
          <span class="count">{{i + 1}} </span>
          <a *ngIf="doc.Url != null && doc.Url != undefiend && doc.Url.length > 0" href="{{doc.Url}}" download target="_blank">{{doc.Name}}</a>
          <span style="cursor:none !important" *ngIf="doc.Url == null || doc.Url == undefiend || doc.Url.length == 0">{{doc.Name}}</span>
          <a style="padding-left:5px" class="ml-auto file-download" *ngIf="doc.Url != null && doc.Url != undefiend && doc.Url.length > 0" href="{{doc.Url}}" download target="_blank">
            <i aria-hidden="true" class="icofont icofont-download-alt"></i>
          </a>
        </p>
      </ng-container>
    </div>
  </div>
</ng-template>
